import React, {Component} from "react"
import {Col, FormInput, InputGroup, Row} from "elemental"

import shop from "../../shop/shop"
import Typeahead from "../../components/Typeahead/Typeahead"
import CustomProductOption from '../../components/CustomProductOption/CustomProductOption'
import ProductTable from '../../components/Product/ProductTable'

export default class QuickorderPage extends Component {
  constructor() {
    super()
    this.state = {
      value: null,
      products:[]
    }
  }

  handleRemoveProduct = (productToRemove) => {
    shop.cart.remove(productToRemove);
  }

  handleSelect = (value) => {
    if (!value) {
      this.setState({value: false})
      return value
    }

    let {product} = value
    product.count = 0
    product.visible = false
    this.setState({value})
    window.setTimeout(() => {
      this.numberInput.focus()
    }, 30)
    return value
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove(this.handleCartUpdate)
  }

  componentDidMount() {
    this.handleCartUpdate(shop) // Call it once to properly setup state.
    shop.cart.hooks.changed.add(this.handleCartUpdate) // Bind it to the cart.
  }

  handleCartUpdate = ({cart}) => {
    let products = cart.map(product => product)
    this.setState({products})
  }

  resetForm = () => {
    let product = this.state.value.product

    if (product.count > 0) {
      product.visible = true
      shop.cart.add(product)
    }
    this.setState({
      value: false
    })
    this.typeaheadInput.focus()
  }

  handleKeys = (e) => {
    const CHAR_ENTER = 13
    // const CHAR_TAB   = 9

    if (e.charCode === CHAR_ENTER) {
      this.resetForm()
      e.preventDefault()
      return false
    }

    // if (e.keyCode === CHAR_TAB) {
    //   this.resetForm()
    //   e.preventDefault()
    // }
  }

  render() {
    let {products, value} = this.state
    let count = 0
    if (value) count = value.product.count

    return (
      <div className="container pt4">
        <h1 className="page-title"><i className="icon-sort-alt-up icon-lg"/><strong>Quickorder</strong></h1>
        <p>Legen Sie bekannte Artikel in den Warenkorb. Navigieren Sie mit <strong>Enter, Tabstop</strong> und dem
          <strong> Nummernblock</strong></p>

        <section>
          <div className="row-title"><h2>Warenkorb</h2></div>
          <ProductTable onChange={this.handleRemoveProduct} products={products} cart={shop.cart}/>
        </section>

        {/*TYPEAHEAD*/}
        <section className="pb2">
          <Row>
            <Col sm="7/8">
              <label htmlFor="">Produkt</label>
              <Typeahead optionComponent={CustomProductOption}
                         onSelect={this.handleSelect}
                         value={this.state.value}
                         setup={(input) => {
                           this.typeaheadInput = input
                         }}/>
            </Col>
            <Col sm="1/8">
              <label htmlFor="">{translate("product.piece")}</label>
              <InputGroup.Section >
                <FormInput
                  type="number"
                  ref={(input) => {
                    this.numberInput = input
                  }}
                  disabled={!this.state.value}
                  onKeyPress={this.handleKeys}
                  onKeyDown={this.handleKeys}
                  onFocus={e => {
                    e.target.select()
                  }}
                  onChange={ (e) => {
                    if (!this.state.value) return
                    let product = this.state.value.product
                    product.count = e.target.value
                    this.setState({product})
                    shop.cart.add(product)
                  }}
                  value={count}
                  placeholder="1"/>
              </InputGroup.Section>
            </Col>
          </Row>
        </section>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/quickorder/QuickorderPage.js